import { useParams } from 'react-router';
import { useOutletContext } from 'react-router-dom';
import { AndroidScreenWithNfcChecks } from '@/components/3ds/AndroidScreen/AndroidScreenWithNfcChecks';
import IPhoneScreenRules from '@/constants/defaultPageRules/3ds/IPhoneScreen.json';
import NotSupportedRules from '@/constants/defaultPageRules/3ds/NotSupported.json';
import type { OutletData } from '@/types/OutletData';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';
import { Spinner } from '@cof/omni-react';
import { AndroidScreen, IPhoneScreen } from '@components/3ds';
import { NotSupported } from '@components/3ds/NotSupported';
import { ErrorScreen_DEPRECIATED } from '@components/ErrorScreen';
import { Facts, useRulesEngine } from '@hooks/useRulesEngine';

// Note: androidMock is used to trick device detection during tests
export const ThreeDS = ({
  androidMock,
  iPhoneMock,
  withWebNfcChecksCancelledMock,
}: {
  androidMock?: boolean;
  iPhoneMock?: boolean;
  withWebNfcChecksCancelledMock?: boolean;
}) => {
  useAirKeyTracePageView('transaction_details');

  const { policyProcessId } = useParams();

  const { bowser, loading } = useOutletContext<OutletData>();

  const rulesResult = useRulesEngine({
    facts: bowser as Facts,
    rules: [NotSupportedRules, IPhoneScreenRules],
  });

  if (loading) return <Spinner data-testid="ThreeDS--Spinner" size="giant" />;

  if (androidMock) return <AndroidScreen processId={policyProcessId!} isDemo />;

  if (rulesResult === 'GenericError')
    return (
      <ErrorScreen_DEPRECIATED
        title="Error"
        body="An unknown error has occurred"
      />
    );

  if (rulesResult === 'NotSupported') return <NotSupported />;

  if (rulesResult === 'IPhoneScreen' || iPhoneMock) return <IPhoneScreen />;

  return (
    <AndroidScreenWithNfcChecks
      processId={policyProcessId}
      withWebNfcChecksCancelledMock={withWebNfcChecksCancelledMock}
    />
  );
};
